import { render, staticRenderFns } from "./HygienicMaterials.vue?vue&type=template&id=5f8f4e44"
import script from "./HygienicMaterials.vue?vue&type=script&lang=js"
export * from "./HygienicMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports